import React from 'react';
import i18n from 'i18n-js';
import { useDispatch, useSelector } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';
import withWidth from '@material-ui/core/withWidth';
import Images from 'components/Images';
import { withRouter } from 'react-router-dom';

const VehicleGroupImages = ({ id }) => {
  const dispatch = useDispatch();
  const { fetchingUploadVehicleImage, fetchedUploadVehicleImageSuccess, fetchingImageAction } =
    useSelector((state) => state.vehicles);

  const { current } = useSelector((state) => state.vehiclesGroups);

  const onSetProfileImage = (payload) => {
    dispatch(vehicleActions.setVehicleProfileImage(id, payload));
  };

  const onDeleteImages = (payload) => {
    dispatch(vehicleActions.deleteVehicleImages(id, payload));
  };

  const onUploadImage = (payload) => {
    dispatch(vehicleActions.uploadVehicleImage(id, payload));
  };

  const onReset = () => {
    dispatch(vehicleActions.resetUploadVehicleImage());
  };

  return (
    <Images
      id={id}
      title={i18n.t('vehicle_groups.images')}
      onSetProfileImage={onSetProfileImage}
      onDeleteImages={onDeleteImages}
      onUploadImage={onUploadImage}
      onReset={onReset}
      sourceType="vehicle_group"
      images={current?.images || []}
      loading={fetchingImageAction}
      loadingUpload={fetchingUploadVehicleImage}
      loadingSuccess={fetchedUploadVehicleImageSuccess}
    />
  );
};

export default withWidth()(withRouter(VehicleGroupImages));
